import { Container, Typography } from '@pwskills/rachnaui';
import React from 'react';

const CircleLoader = () => {
  return (
    <Container className="relative w-full h-full flex flex-col justify-center items-center">
      <div className="w-full h-[300px]">
        <img
          src="/images/accountImage/circle_filling_loading.gif"
          alt="success"
          className="w-full h-full object-contain"
        />
      </div>
      <Typography variant="semi-bold" component="h4" className="text-gray-800 text-center -mt-16">
        Building your personalised dashboard..
      </Typography>
    </Container>
  );
};

export default CircleLoader;
